import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const es = {
  IBCorporate: 'IB corporativo',
  IBIndividual: 'IB individual',
  MAMIndividual: 'MAM individual',
  MAMMasterWithLPOA: 'MAM individual',
  MarkupConfirmation: 'Confirmación de margen',
  UserCorporate: 'Usuario corporativo',
  UserIndividual: 'Usuario individual',
  UserJoint: 'Usuario conjunto',
  account: {
    bankingDetails: 'Datos bancarios',
    createANewAccount: 'Crea una cuenta nueva',
    register: 'Registro',
    registerSignInTitle: '¿Ya es usuario?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Es MAM',
        isSales: 'Es usuario de ventas',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'Informe FTD_UTM',
        menuTitle: 'Informe FTD_UTM',
      },
    },
  },
  adminSocialTrading: {
    title: 'Perdagangan Sosial',
    investorAccountDetails: {
      tradingAccountName: 'Nombre de la cuenta de trading',
      balance: 'Balance',
      login: 'Acceso',
    },
    masterAccountDetails: {
      copyType: 'Tipo de copia',
      groupMappingType: 'Group Mapping Type',
      login: 'Acceso',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Collect your Birthday gift',
    availableTable: {
      bonusSize: 'Bonus Size',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'No se encuentra la página',
    },
    captcha: {
      captchaServerIsUnavailable:
        'El servidor Captcha no está disponible. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con soporte a través del chat en línea o por correo electrónico a {{clientSupportEmail}}',
    },
    files: {
      fileWasNotUploaded: 'El archivo no fue cargado',
    },
    mam: {
      linkIsInactive: 'El enlace usado no está activo',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Tenga en cuenta que se ha excedido el límite máximo para el reparto de beneficios. El límite máximo es {{maxLimit}}%.',
      notEnoughMoney:
        'We apologize, but you do not have enough funds in your trading account to process the requested withdrawal. Please ensure that you have a sufficient balance available before attempting a withdrawal. Please note that in addition to the available balance, you should also consider the free margin level required for withdrawals.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'The Master account is ineligible to be copied at this time, please try again later.',
    },
    securityCode: {
      emptyValue: 'The entered security value (password or PIN code) cannot be empty or null',
      invalidLength: 'The entered security value (password or PIN code) must contain {{0}} character(s)',
      invalidMinLength: 'The entered security value (password or PIN code) must contain at least {{0}} character(s)',
      invalidMaxLength: 'The entered security value (password or PIN code) must not exceed {{0}} character(s)',
      manyRepeatedValues:
        'The entered security value (password or PIN code) must not have more than {{0}} repeated character(s)',
      missingNumericValues: 'The entered security value (password or PIN code) must contain numeric character(s)',
      containsNumericValues: 'The entered security value (password or PIN code) must not contain any numeric values',
      missingLowerCaseValues: 'The entered security value (password or PIN code) must contain lowercase character(s)',
      containsLowerCaseValues:
        'The entered security value (password or PIN code) must not contain any lowercase values',
      missingUpperCaseValues: 'The entered security value (password or PIN code) must contain uppercase character(s)',
      containsUpperCaseValues:
        'The entered security value (password or PIN code) must not contain any uppercase values',
      missingSpecialValues: 'The entered security value (password or PIN code) must contain special character(s)',
      containsSpecialValues:
        'The entered security value (password or PIN code) must not contain any special characters',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Sorry for the inconvenience, but the account {{0}} has been disabled',
      ageIsAboveMaxAllowed: 'We do not accept applications from anyone under {{0}} or over {{1}} years old.',
      ageIsUnderMinAllowed: 'We do not accept applications from anyone under {{0}} years old.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "The IB code '{{0}}' is incorrect. Please enter a valid IB code",
      invalidCredentials: 'Invalid username {{0}} and/or password',
      invalidLengthOfPhoneNumber: 'The phone number length is invalid, please try again',
      invalidLink: 'The link is invalid',
      invalidPhoneNumberLength: 'The phone number length is invalid, please try again',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: "User {{0}} doesn't exist",
      userEmailAlreadyExists: 'User email has been already registered in the system',
      userPhoneAlreadyExists: 'User phone has been already registered in the system',
      cantUpdateProfileActualStatus: 'No se puede actualizar la cuenta {{0}}, estado actual = {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'o arrastre aquí sus archivos',
    exportFormat: 'Formato de la exportación',
    getCode: 'Obtener código',
    hide: 'Ocultar',
    limitMessage: '{{limit}} caracteres restantes',
    resend: 'Reenviar',
    seconds: 'seg',
    show: 'Mostrar',
  },
  headerWithBalance: {
    serverTime: 'Hora del servidor',
    failedToFetchServerTime: 'No se pudo obtener la hora del servidor',
    view: 'Vista',
  },
  investors: {
    blackList: 'Lista negra',
  },
  legal: {
    clientAgreement: 'Acuerdo del cliente',
    privacyPolicy: 'Política de privacidad',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'Sobre el proveedor',
    infoFields: {
      ibCode: 'Código IB',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Apodo del proveedor',
      rating: 'Posición en la clasificación',
    },
  },
  menu: {
    deposit: 'Depósito',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked:
        "La cuenta de seguidor comenzó a copiar la cuenta de proveedor '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Se creó la cuenta de seguidor. La cuenta de seguidor comenzó a copiar la cuenta de proveedor '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked:
        "La cuenta de seguidor dejó de copiar la cuenta de proveedor '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Se modificó la cuenta maestra. (Reparto de beneficios={{ProfitSharing}}, Método de asignación={{AllocationMethod}})',
      MasterAccountWasLinked:
        "La cuenta de seguidor '{{InvestorAccountName}}' comenzó a copiar la cuenta de proveedor.",
      MasterAccountWasOpened:
        'Se creó la cuenta maestra. (Reparto de beneficios={{ProfitSharing}}, Método de asignación={{AllocationMethod}})',
      MasterAccountWasUnlinked:
        "La cuenta de seguidor '{{InvestorAccountName}}' dejó de copiar la cuenta de proveedor.",
    },
  },
  modal: {
    error: 'Error',
    notification: 'Notificación',
    ok: 'OK',
  },
  operationHistory: {
    filterName: 'Buscar',
    placeholder: 'Por favor, introduce',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Ventas',
    ibInfo: {
      detailsTitle: 'Detalles IB',
      nextRebatePayment: 'Próximo pago de rebates',
      statistics: {
        closetTradersReport: {
          type: 'Tipo',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError:
        '¡Los márgenes son incorrectos! Póngase en contacto con nuestro equipo de soporte para obtener márgenes correctos',
    },
    salesUserInfo: {
      aeCode: 'Código AE',
    },
  },
  profile: {
    adult: 'Tengo mas de 18 años',
    code: 'Código',
    country: 'País',
    documentsUploaded: 'Documentos cargados',
    isAgreeWithTermsAndConditions: 'Acepto el <0>Acuerdo del cliente</0> y la <1>Política de privacidad</1>',
    pleaseValidateAccountToDeposit:
      'Sus datos personales requieren verificación por parte del equipo de cumplimiento de {{brokerName}}. Antes de proceder al depósito, debe enviar un escaneo de su identificación',
    successChangeDescription: '¡Los cambios se han guardado!',
    warningMessage: {
      profileIsBeingVerified: 'Su perfil está siendo verificado, puede tardar un par de segundos',
    },
  },
  psp: {
    accountsFetchFailErr: 'Error al obtener cuentas',
    confirmEveryTransaction: 'Confirmando todas las transacciones, los depósitos pueden tardar hasta 24 horas',
    deposit: {
      depositForm: {
        accountNameTitle: 'Nombre de la cuenta',
        addressLine2: 'Dirección línea 2',
        beneficiaryAccountNumberTitle: 'Número de cuenta del beneficiario',
        beneficiaryBankHint: 'Por favor, seleccione el número de cuenta bancaria',
        beneficiaryBankNameHint: 'Nombre del banco, p. ej. (Banco registrado estándar)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Adjunte un documento que confirme el pago si es necesario',
      },
      depositTitle: 'Depositar Fondos',
      notice: 'Los depósitos están disponibles solo para cuentas verificadas',
      warnToSubmitPersonalDetails:
        'Para realizar un depósito, envíe sus datos personales. Por favor, asegúrese de que coincidan con los datos de su ID',
    },
    localAgentTable: {
      login: 'Usuario',
    },
    operationsFetchFailErr: 'Error al obtener operaciones',
    operationsTable: {
      documentTitle: 'Documento',
      operationsTableTitle: 'Operaciones recientes',
      paymentSystemTitle: 'Sistema de pago',
    },
    pluginInfoFetchFailErr: 'No se pudo obtener la información del complemento',
    pluginNotFound: 'Complemento no encontrado',
    pluginsFetchFailErr: 'No se pudieron obtener los complementos',
    preAuthorizedBanking: 'Banca preautorizada',
    qrCodeCryptoNotice:
      'El código QR es de un solo uso. No escanee este código en una aplicación cripto más de una vez, de lo contrario, se suspenderá su pago.',
    qrCodeCryptoTitle: 'Código QR para la aplicación cripto',
    resentOperationsTitle: 'Operaciones recientes',
    transfer: {
      transactionDetailsTitle: 'Datos de la transacción',
      transferForm: {
        amountError: 'Se excedió el importe de la transferencia disponible',
        currencyTitle: 'Divisa',
      },
    },
    uploadBankStatementWithBankName:
      'Cargar un extracto bancario que contenga el nombre del banco, su nombre completo y el número de cuenta bancaria',
    uploadPayslip: 'Cargar el comprobante bancario de su depósito',
    uploadYourDocument: 'Confirme su depósito cargando su extracto bancario',
    withdrawal: {
      notice: 'Las retiradas están disponibles solo para cuentas verificadas',
      withdrawalTitle: 'Retirar Fondos',
      withdrawalForm: {
        bankNameTitle: 'Nombre del banco',
        beneficiaryCryptoWalletHint: 'Se enviará un número de billetera con dinero en criptomonedas a',
        beneficiaryCryptoWalletTitle: 'Billetera criptográfica del beneficiario',
        confirmTitle: 'Confirmar información de la retirada',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'Compruebe si el número de identificación es el mismo que en la foto',
      documentTypeHint: 'Asegúrese de proporcionar una foto de alta calidad o un escaneo de un documento válido',
      uploadedDocumentsTable: {
        docNameTitle: 'Nombre del documento',
        documentNumber: 'Número del documento',
        typeTitle: 'Tipo de Documento',
      },
    },
    profileForm: {
      editProfileTitle: 'Editar perfil',
      proceedToDeposit: 'Proceder al depósito',
      saveUserSuccessMessage: 'El perfil se guardó con éxito',
      userDetailsErrorMessage: 'No se pudo obtener el perfil de usuario',
      verifyPersonalDetails: 'Verificar datos personales',
      verifyProfileBtn: 'Verificar perfil',
    },
  },
  socialTradingModal: {
    copyHint: 'Su cuenta {{account}} dejará de copiar al proveedor {{oldMaster}} y empezará a copiar a {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Cuenta de trading',
    accountHistoryForm: {
      closeTimeTitle: 'Hora de cierre',
    },
    changeTradingAccountName: 'Cambiar el nombre de la cuenta de trading',
    connectedAccounts: 'Cuentas conectadas',
    currency: 'Divisa',
    depositForm: {
      amountTitle: 'Importe',
      errorMessage: 'Error al depositar fondos',
      successMessage: 'El depósito se realizó con éxito',
    },
    descriptionPlaceholder: 'Introduzca una recomendación para sus seguidores',
    fetchServersErr: 'No se pudieron obtener los servidores',
    ibCode: 'IB (opcional)',
    notRows: 'No hay filas que mostrar',
    openAccountModalSubTitle:
      'La más amplia variedad de instrumentos de trading: divisas, metales. Condiciones operativas estándar.',
    tradingPlatforms: 'Plataformas de trading',
    transferForm: {
      title: 'Transferir fondos',
    },
    withdrawForm: {
      amountTitle: 'Importe',
      errorMessage: 'No se pudo guardar el apalancamiento',
      successMessage: 'La retirada se realizó con éxito',
    },
  },
} satisfies ILocaleLegacy;
